import { applyElementOverrides } from "./applyOverrides";
import { applyTheme, DEFAULT_THEME } from "./theme";

export function initEditorBridge() {
  const params = new URLSearchParams(window.location.search);
  const isEditor = params.get("editor") === "1";
  const isPreview = params.get("preview") === "1";
  if (!isEditor && !isPreview) return;

  fetch(`/api/admin/editor/draft`, { credentials: "include" })
    .then((r) => (r.ok ? r.json() : null))
    .then((draft) => {
      if (!draft) return;
      if (draft.theme) applyTheme({ ...DEFAULT_THEME, ...draft.theme });
      if (draft.element_overrides) {
        setTimeout(() => applyElementOverrides(draft.element_overrides), 500);
      }
    })
    .catch(() => {});

  if (!isEditor) return;

  let highlighted = null;
  const setOutline = (el, on) => {
    if (el) el.style.outline = on ? "2px solid #D4AF37" : "";
  };
  document.addEventListener("mouseover", (e) => {
    const el = e.target.closest("[data-eid]");
    if (highlighted && highlighted !== el) setOutline(highlighted, false);
    highlighted = el;
    setOutline(el, true);
  }, true);
  document.addEventListener("click", (e) => {
    const el = e.target.closest("[data-eid]");
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    window.parent.postMessage(
      {
        source: "hc-editor",
        type: "select",
        eid: el.dataset.eid,
        etype: el.dataset.etype || "text",
        text: (el.textContent || "").trim().slice(0, 300),
        tag: el.tagName,
      },
      "*"
    );
  }, true);

  window.addEventListener("message", (e) => {
    if (e.data?.source !== "hc-editor-parent") return;
    if (e.data.type === "apply") {
      applyElementOverrides({ [e.data.eid]: e.data.override });
    } else if (e.data.type === "applyAll") {
      document.querySelectorAll("[data-eid]").forEach((el) => {
        if (el.dataset.origText !== undefined) el.textContent = el.dataset.origText;
        if (el.dataset.origSrc) el.src = el.dataset.origSrc;
      });
      applyElementOverrides(e.data.overrides || {});
    }
  });
}
